import { createFileRoute } from "@tanstack/react-router";
import { lazy, Suspense } from "react";

import Loading from "../../components/shared/Loading";
import PageContainer from "../../components/template/PageContainer";
import { protectedLeaf } from "../../router/route-contracts";

const Screen = lazy(() => import("../../views/oficinas3r"));

export const Route = createFileRoute("/_protected/oficinas3r")({
  component: RouteComponent,
  staticData: protectedLeaf({
    requiredRoles: [],
    routeKey: "oficinas3r",
    access: "protected",
    layout: "modern",
    container: "default",
  }),
});

function RouteComponent() {
  return (
    <Suspense fallback={<Loading loading={true} />}>
      <PageContainer
        pageContainerType={Route.options.staticData?.container}
        footer={Route.options.staticData?.footer}
      >
        <Screen />
      </PageContainer>
    </Suspense>
  );
}
